import React, { Component } from "react";
import styles from "../PricingWrapper.module.scss";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import PositiveValue from "../../../../utils/PostiveValue";
import { FEES_MAP } from "../../../../common/Constants";
import UpperCaseText from "../../../../utils/UpperCaseText";
import { fileDownload } from "../../../../utils/FileDownloadUtil";

class ExportAll extends Component {
  downloadPricingReport = () => {
    const feesDataMap = new Map();
    this.props.feesData.forEach(function (val) {
      feesDataMap.set(val.entity, val);
    });
    const pricingDataMap = [];
    this.props.pricingData.forEach((row) => {
      let fees = null;
      const data = row;
      data.dealerVehiclePrice =
        row.rrp - row.vm.customerSaving - PositiveValue(row.adj);
      const feeSet = feesDataMap.get(row.entityId);
      if (feeSet) {
        FEES_MAP[UpperCaseText(this.props.user.market)].forEach((fee) => {
          fees = fees + feeSet[fee.key];
        });
      }
      data.transactionPrice = data.dealerVehiclePrice + fees;
      data.vm = data.vm && data.vm.customerSaving;
      pricingDataMap.push(data);
    });
    const replacer = function (key, value) {
      return value === null ? "--" : value;
    };
    //getting the headers for the dealer fees
    const feesMap = FEES_MAP[UpperCaseText(this.props.user.market)];
    const dealerFeesReportAndValues = {
      specs: this.props.t("PricingHeader.specification"),
      year: this.props.t("PricingHeader.year"),
    };
    //adding the fees data to the file for header
    feesMap &&
      feesMap.forEach((data) => {
        dealerFeesReportAndValues[data.key] = this.props.t(data.name);
      });
    const feesFields = Object.keys(dealerFeesReportAndValues);
    //adding the fees info to the table
    let feesCSV = this.props.feesData.map(function (row) {
      return feesFields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(",");
    });
    feesCSV.unshift(Object.values(dealerFeesReportAndValues).join(","));
    feesCSV = feesCSV.join("\r\n");

    //getting the vehicle pricing header
    const vehicleReportAndValues = {
      specs: this.props.t("PricingHeader.specification"),
      year: this.props.t("PricingHeader.year"),
      rrp: this.props.t("PricingHeader.rrp"),
      vm: this.props.t("DealerVehicles.vm"),
      adj: this.props.t("DealerVehicles.discount"),
      dealerVehiclePrice: this.props.t("PricingHeader.dealerVehiclePrice"),
      transactionPrice: this.props.t("PricingHeader.dealerTransactionPrice"),
    };
    const pricingFields = Object.keys(vehicleReportAndValues);

    // adding the vehicles data to table
    let vehiclesCSV = pricingDataMap.map(function (row) {
      return pricingFields
        .map(function (fieldName) {
          return JSON.stringify(row[fieldName], replacer);
        })
        .join(",");
    });
    vehiclesCSV.unshift(Object.values(vehicleReportAndValues).join(","));
    vehiclesCSV = vehiclesCSV.join("\r\n");

    //getting the vehicle pricing header
    const optionsReportAndValues = {
      featureDesc: this.props.t("Options.specification"),
      year: this.props.t("Options.year"),
      rrp: this.props.t("Options.rrp"),
      vm: this.props.t("Options.discount"),
      adj: this.props.t("Options.recommendedAdjustment"),
      recommendedPrice: this.props.t("Options.recommendedPrice"),
    };
    const optionsFields = Object.keys(optionsReportAndValues);

    // adding the options data to table
    let optionsCSV = this.props.optionsData.map(function (row) {
      return optionsFields
        .map(function (fieldName) {
          if (fieldName === "recommendedPrice") {
            const recommendedPrice =
              parseFloat(row["rrp"]) -
              parseFloat(row["vm"]) +
              parseFloat(row["adj"]);
            return JSON.stringify(recommendedPrice, replacer);
          } else {
            return JSON.stringify(row[fieldName], replacer);
          }
        })
        .join(",");
    });
    optionsCSV.unshift(Object.values(optionsReportAndValues).join(","));
    optionsCSV = optionsCSV.join("\r\n");

    let effDateText = "";
    if (this.props.futureEffectiveDate) {
      effDateText =
        UpperCaseText(this.props.t("CurrentPricing.futurePricingEffective")) +
        this.props.futureEffectiveDate +
        "\r\n\n";
    }

    const csv =
      effDateText +
      UpperCaseText(this.props.t("CurrentPricing.dealerFees")) +
      "\r\n" +
      "\n" +
      feesCSV +
      "\r\n" +
      "\n" +
      UpperCaseText(this.props.t("CurrentPricing.vehicles")) +
      "\r\n" +
      "\n" +
      vehiclesCSV +
      "\r\n" +
      "\n" +
      UpperCaseText(this.props.t("CurrentPricing.options")) +
      "\r\n" +
      "\n" +
      optionsCSV;
    const filename =
      this.props.selectedModel + this.props.selectedYear + "- PricingData.csv";
    fileDownload(
      csv,
      "text/csv;charset=utf-8;",
      filename,
      "pricing-data-report"
    );
  };

  render() {
    return (
      <div>
        <HasPermissionTo
          perform={["pricingExport:view"]}
          permissions={this.props.user.permissions.rolePermissions}
          render={() => {
            return (
              <div
                className={styles.exportAllDiv}
                data-testid="exportAllBtn"
                onClick={this.downloadPricingReport}
              >
                <div className={styles.exportIcon} />
                <span className={styles.exportAll}>
                  {" "}
                  {this.props.t("DealerVehicles.export")}
                </span>
              </div>
            );
          }}
        />
      </div>
    );
  }
}

export default ExportAll;
